module.exports = __webpack_public_path__ + "img/content4.600d4be4.png";